/*
 *
 * Copyright 2019, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */

import React from "react";
import "./WrcPageFooter.css"
import PropTypes from "prop-types";

export class WrcPageFooter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            theyear: new Date().getFullYear()
        };
    }

    render() {
        return (
            <footer className='bp3-ui-text wd-footer'>
                <p>Copyright &copy; {this.state.theyear} <a href="https://www.whiterivercomputing.com/" target="_blank" style={{color: 'white', fontWeight: 'bold'}}>White River Computing</a>. All rights reserved. Version {this.props.version}</p>
            </footer>
        )
    }
}

WrcPageFooter.propTypes = {
    version: PropTypes.string.isRequired,
};
